
const state = {
  sharecarInfo: []
}

const actions = {
  updateData (ctx, item) {
    ctx.commit('updateData', item)
  }
}

const mutations = {
  updateData (state, item) {
    state.sharecarInfo = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
